/** @format */
import { LoginMode, useAuthContext } from '@mpb-com/auth-sdk/client';
import React, { useCallback, useContext } from 'react';

import { IDP_FORGOTTEN_PASSWORD_PATH } from '@toucan/common/services/oauth/constants';
import { getIdpLocale } from '@toucan/common/services/oauth/helpers';

import {
    ApplicationContext,
    ModalSize,
} from '@toucan/client/global/application';
import { MarketContext } from '@toucan/client/global/market';

/* eslint-disable-next-line boundaries/element-types -- This hook owns the one
 * branch between the legacy MPBX reset modal and the IdP redirect, so it has to
 * know about RequestPasswordReset component.
 */
import { RequestPasswordReset } from '@toucan/client/shared/components/request-password-reset';

export type UseRequestPasswordResetReturn = {
    startPasswordReset: (email?: string) => void;
};

export const useRequestPasswordReset = (): UseRequestPasswordResetReturn => {
    const { loginMode } = useAuthContext();
    const { setModalContent, setModalVisible } = useContext(ApplicationContext);
    const { activeMarket } = useContext(MarketContext);

    const isIdpPasswordResetEnabled = loginMode === LoginMode.OAUTH;

    const startPasswordReset = useCallback(
        (email = '') => {
            if (isIdpPasswordResetEnabled) {
                const idpLocale = getIdpLocale(activeMarket?.slug);

                window.location.assign(
                    idpLocale
                        ? `${IDP_FORGOTTEN_PASSWORD_PATH}?locale=${idpLocale}`
                        : IDP_FORGOTTEN_PASSWORD_PATH
                );
                return;
            }

            setModalContent(<RequestPasswordReset initialEmail={email} />);
            setModalVisible(true, { size: ModalSize.SMALL });
        },
        [
            isIdpPasswordResetEnabled,
            activeMarket?.slug,
            setModalContent,
            setModalVisible,
        ]
    );

    return { startPasswordReset };
};
